var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup41962(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.351,
    height: 70.775,
    viewBox: "0 0 67.351 70.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41962",
    "data-name": "Group 41962",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17828",
    "data-name": "Rectangle 17828",
    width: 12.557,
    height: 26.255,
    rx: 3,
    transform: "translate(28.767)",
    fill: "#b3b3ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41943",
    "data-name": "Group 41943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "civil",
    transform: "translate(3.653 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41938",
    "data-name": "Group 41938",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6963",
    "data-name": "Path 6963",
    d: "M49.557,27h-9.35a1.18,1.18,0,0,0-1.169,1.191v1.191a1.18,1.18,0,0,1-1.169,1.191H30.857a1.18,1.18,0,0,1-1.169-1.191V28.191A1.18,1.18,0,0,0,28.519,27h-9.35a1.191,1.191,0,0,0,0,2.382H27.35a3.54,3.54,0,0,0,3.506,3.574h7.013a3.54,3.54,0,0,0,3.506-3.574h8.181a1.191,1.191,0,0,0,0-2.382Z",
    transform: "translate(-2.514 2.463)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6964",
    "data-name": "Path 6964",
    d: "M63.927,30.428A26.981,26.981,0,0,0,43.9,5.311,3.532,3.532,0,0,0,40.387,2H33.31a3.532,3.532,0,0,0-3.516,3.321A26.92,26.92,0,0,0,9.763,30.428,5.9,5.9,0,0,0,5,36.208v2.359a3.539,3.539,0,0,0,3.539,3.539h1.18v8.257a1.18,1.18,0,0,0,1.18,1.18h6.776a20.016,20.016,0,0,0,1.444,3.489l-4.784,4.8a1.18,1.18,0,0,0,0,1.668L21,68.159a1.18,1.18,0,0,0,1.668,0l4.8-4.784a20.016,20.016,0,0,0,3.49,1.445V71.6a1.18,1.18,0,0,0,1.18,1.18h9.437a1.18,1.18,0,0,0,1.18-1.18V64.82a19.677,19.677,0,0,0,3.482-1.453l4.8,4.794a1.18,1.18,0,0,0,1.668,0L59.363,61.5a1.18,1.18,0,0,0,0-1.668l-4.793-4.8a19.673,19.673,0,0,0,1.453-3.483H62.8a1.18,1.18,0,0,0,1.18-1.18V42.106h1.18A3.539,3.539,0,0,0,68.7,38.567V36.208A5.9,5.9,0,0,0,63.927,30.428ZM61.62,49.183H55.132a1.18,1.18,0,0,0-1.142.884,17.282,17.282,0,0,1-1.9,4.55,1.18,1.18,0,0,0,.177,1.439l4.593,4.6-5,5-4.6-4.593a1.18,1.18,0,0,0-1.44-.177,17.242,17.242,0,0,1-4.548,1.9,1.18,1.18,0,0,0-.887,1.144v6.488H33.31V63.928a1.18,1.18,0,0,0-.884-1.142A17.669,17.669,0,0,1,27.858,60.9a1.18,1.18,0,0,0-1.432.18l-4.592,4.581-5-5,4.581-4.592a1.18,1.18,0,0,0,.18-1.432,17.669,17.669,0,0,1-1.887-4.567,1.18,1.18,0,0,0-1.145-.888H12.077V42.106H25.616a11.8,11.8,0,1,0,22.466,0H61.62ZM45.578,42.106a9.437,9.437,0,1,1-17.458,0Zm20.761-3.539a1.18,1.18,0,0,1-1.18,1.18H8.539a1.18,1.18,0,0,1-1.18-1.18V36.208a3.539,3.539,0,0,1,2.359-3.322v3.322a1.18,1.18,0,0,0,2.359,0V31.49A24.6,24.6,0,0,1,29.771,7.772V23.232a1.18,1.18,0,0,0,2.359,0V5.539a1.18,1.18,0,0,1,1.18-1.18h7.077a1.18,1.18,0,0,1,1.18,1.18V23.232a1.18,1.18,0,0,0,2.359,0V7.756A24.728,24.728,0,0,1,61.62,31.49v4.718a1.18,1.18,0,0,0,2.359,0V32.886a3.539,3.539,0,0,1,2.359,3.322Z",
    transform: "translate(-5 -2)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6965",
    "data-name": "Path 6965",
    d: "M41.191,19.53a1.191,1.191,0,0,0,1.191-1.191V11.191a1.191,1.191,0,0,0-2.382,0v7.147A1.191,1.191,0,0,0,41.191,19.53Z",
    transform: "translate(1.27 -0.47)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6966",
    "data-name": "Path 6966",
    d: "M23.191,19.53a1.191,1.191,0,0,0,1.191-1.191V11.191a1.191,1.191,0,0,0-2.382,0v7.147A1.191,1.191,0,0,0,23.191,19.53Z",
    transform: "translate(-1.955 -0.47)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6967",
    "data-name": "Path 6967",
    d: "M50.382,27H49.191a1.191,1.191,0,1,0,0,2.382h1.191a1.191,1.191,0,1,0,0-2.382Z",
    transform: "translate(2.594 2.48)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6968",
    "data-name": "Path 6968",
    d: "M15.382,27H14.191a1.191,1.191,0,1,0,0,2.382h1.191a1.191,1.191,0,1,0,0-2.382Z",
    transform: "translate(-3.47 2.48)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6969",
    "data-name": "Path 6969",
    d: "M13,38h2.382v2.382H13Z",
    transform: "translate(-3.47 4.451)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6970",
    "data-name": "Path 6970",
    d: "M0,0H2.382V2.382H0Z",
    transform: "translate(15.149 58.534) rotate(-45)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6971",
    "data-name": "Path 6971",
    d: "M31,56h2.382v2.382H31Z",
    transform: "translate(-0.343 7.628)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6972",
    "data-name": "Path 6972",
    d: "M0,0H2.382V2.382H0Z",
    transform: "translate(45.157 58.538) rotate(-45)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6973",
    "data-name": "Path 6973",
    d: "M49,38h2.382v2.382H49Z",
    transform: "translate(2.785 4.451)",
    fill: "#3335cf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41942",
    "data-name": "Group 41942",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41939",
    "data-name": "Group 41939",
    transform: "translate(9.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M207.9,27.008a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,207.9,27.008Zm0-2.731a.535.535,0,1,0,.535.536A.536.536,0,0,0,207.9,24.277Z",
    transform: "translate(-205.701 -22.617)",
    fill: "#ff7b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41940",
    "data-name": "Group 41940",
    transform: "translate(56.533 63.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M315.5,115.821a.827.827,0,0,1-.587-.243l-1.874-1.874a.83.83,0,0,1,0-1.174l1.874-1.874a.83.83,0,0,1,1.174,0l1.874,1.874a.83.83,0,0,1,0,1.174l-1.874,1.874A.827.827,0,0,1,315.5,115.821Zm-.7-2.7.7.7.7-.7-.7-.7Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41941",
    "data-name": "Group 41941",
    transform: "translate(61.942 11.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M45.12,323.057a.83.83,0,0,1-.587-.243l-1.874-1.874a.83.83,0,0,1,0-1.174l1.874-1.874a.83.83,0,0,1,1.174,0l1.874,1.874a.83.83,0,0,1,0,1.174l-1.874,1.875A.83.83,0,0,1,45.12,323.057Zm-.7-2.7.7.7.7-.7-.7-.7Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6974",
    "data-name": "Path 6974",
    d: "M19.787,140.5a1.377,1.377,0,0,0,1.377-1.377v-1.377h1.377a1.377,1.377,0,1,0,0-2.754H21.164v-1.377a1.377,1.377,0,1,0-2.754,0v1.377H17.033a1.377,1.377,0,1,0,0,2.754H18.41v1.377A1.377,1.377,0,0,0,19.787,140.5Z",
    transform: "translate(-15.656 -79.357)",
    fill: "#ff7b00"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup41962);
export default __webpack_public_path__ + "static/media/Group 41962.c38bc346042ab774958ff7c84366e14b.svg";
export { ForwardRef as ReactComponent };